/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75070ResReceiveChatRespObjChatSessionRespListItem {
  
  /** 会话id */
  sessionToken?: string;
  
  /** 会话名称 */
  sessionName?: string;
  
  /** 是否已读 */
  isRead?: boolean;
  
};
    
  
    
export interface IAPI75070ResReceiveChatRespObj {
  
  /** 分类数据 ,ChatSessionQryResp */
  chatSessionRespList?: IAPI75070ResReceiveChatRespObjChatSessionRespListItem[];
  
  /** 分类标题 */
  classicTitle?: string;
  
};
    
  
    
export interface IAPI75070ResInitiateChatRespObjChatSessionRespListItem {
  
  /** 会话id */
  sessionToken?: string;
  
  /** 会话名称 */
  sessionName?: string;
  
  /** 是否已读 */
  isRead?: boolean;
  
};
    
  
    
export interface IAPI75070ResInitiateChatRespObj {
  
  /** 分类数据 ,ChatSessionQryResp */
  chatSessionRespList?: IAPI75070ResInitiateChatRespObjChatSessionRespListItem[];
  
  /** 分类标题 */
  classicTitle?: string;
  
};
    
  
    
export interface IAPI75070ResFinishChatRespObjChatSessionRespListItem {
  
  /** 会话id */
  sessionToken?: string;
  
  /** 会话名称 */
  sessionName?: string;
  
  /** 是否已读 */
  isRead?: boolean;
  
};
    
  
    
export interface IAPI75070ResFinishChatRespObj {
  
  /** 分类数据 ,ChatSessionQryResp */
  chatSessionRespList?: IAPI75070ResFinishChatRespObjChatSessionRespListItem[];
  
  /** 分类标题 */
  classicTitle?: string;
  
};
    
  
    
export interface IAPI75070ResAppStoreRespItem {
  
  /** 应用id */
  appId?: number;
  
  /** 应用类型 */
  appType?: string;
  
  /** 应用名称 */
  appTitle?: string;
  
};
    
  



export interface API75070Req {
  
  /** 业务编号 */
  sessionName?: string;
};



export interface API75070Res {
  /** 今日任务数  */
  todayTaskCount?: number;
  /** 接受任务聊天 ,AppClassicChatResp  */
  receiveChatResp?: IAPI75070ResReceiveChatRespObj;
  /** 发起的聊天 ,AppClassicChatResp  */
  initiateChatResp?: IAPI75070ResInitiateChatRespObj;
  /** 已完成聊天 ,AppClassicChatResp  */
  finishChatResp?: IAPI75070ResFinishChatRespObj;
  /** 商店 ,AppStoreResp  */
  appStoreResp?: IAPI75070ResAppStoreRespItem[];
  
};


// 接口函数 75070 查询会话窗口

export interface IUsePostAPI75070Return {
  /** 查询会话窗口: 接口请求状态 */
  isAPI75070Loading: boolean;
  /** 查询会话窗口: 接口请求返回数据 */
  dataAPI75070: API75070Res;
  /**  查询会话窗口: 接口数据请求方法 */
  fetchAPI75070Data: (inputs: API75070Req, config?: YWRequestConfig) => Promise<API75070Res>;
  /** 查询会话窗口: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75070 = ():IUsePostAPI75070Return => {
  let isMount = true;
  const [isAPI75070Loading, setIsAPI75070Loading] = useState(false);
  const [dataAPI75070, setDataAPI75070] = useState<API75070Res>({} as API75070Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/app/query`;

  const fetchAPI75070Data = async (inputs: API75070Req, config?: YWRequestConfig): Promise<API75070Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75070Req>) || {}) as API75070Req;
    
  
    if ( isMount ) {
      setIsAPI75070Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75070Res>(`${basePath}/yoaichat-web/chat/app/query`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75070(res || {} as API75070Res);
        setIsAPI75070Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75070Loading(false);
      }
      return false as unknown as API75070Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75070Loading,
    dataAPI75070,
    fetchAPI75070Data,
    requestUrl,
  }
}

